import { clsx } from '@mantine/styles'

import styles from './BadgeAnimation.module.scss'
import { Flex } from '@percent/lemonade'
import { AchievementDetails } from '@percent/workplace-giving/api/account/achievements/achievements.types'

type BadgeAnimationProps = {
  isActive: boolean
  badge: AchievementDetails
}

export function BadgeAnimation({ isActive, badge }: BadgeAnimationProps) {
  return (
    <Flex
      justify="center"
      align="flex-start"
      className={clsx(styles.AnimationWrapper, { [styles.Active]: isActive })}
      data-testid="badgeAnimation"
    >
      <div className={styles.BadgeBackground}>
        <div className={clsx(styles.BadgeWrapper, { [styles.Active]: isActive })}>
          <div className={styles.BadgeRibbon} />
          <div className={styles.BadgeRibbon} />
          <div className={styles.BadgeImg} style={{ backgroundImage: `url(${badge.image})` }} />
        </div>
        <div className={clsx(styles.Shine, { [styles.Active]: isActive })} />
      </div>
    </Flex>
  )
}
